var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { css } from 'styled-components';
import { designSchema } from '../../../contexts/designs/utils';
import { styledWithoutNonHTMLProps } from '../../../theme/utils';
import { propsToNotForward } from './BaseInput.types';
var numberMixin = function (_a) {
    var type = _a.type;
    return type === 'number' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    -moz-appearance: textfield;\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n  "], ["\n    -moz-appearance: textfield;\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n  "])));
};
export var StyledBaseInput = styledWithoutNonHTMLProps('input', propsToNotForward)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), designSchema, numberMixin);
var templateObject_1, templateObject_2;
